import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import MoreSheet from './more-sheet';
import MoreIcon from '../../../common/icons/more';
import { splitBottomNav } from '../menu';

import '../styles/bottom-nav.css';

function BarIcon({ Icon, badge }) {
    return (
        <span className="bottom-nav__icon">
            <Icon size={22} />
            {badge > 0 && <span className="bottom-nav__badge" aria-hidden="true">{badge}</span>}
        </span>
    );
}

export default function BottomNav({ items, badges }) {
    const [isMoreOpen, setIsMoreOpen] = useState(false);
    const location = useLocation();
    const { primary, overflow } = splitBottomNav(items);

    const isOverflowActive = overflow.some((item) => location.pathname.startsWith(item.path));
    const overflowBadge = overflow.reduce((sum, item) => sum + (badges[item.key] || 0), 0);

    return (
        <nav className="bottom-nav" aria-label="Principal">
            <ul className="bottom-nav__list">
                {primary.map(({ key, label, shortLabel, path, Icon }) => (
                    <li key={key} className="bottom-nav__item">
                        <NavLink
                            to={path}
                            aria-label={badges[key] > 0 ? `${label}, ${badges[key]} pendientes` : label}
                            className={({ isActive }) => `bottom-nav__link${isActive ? ' bottom-nav__link--active' : ''}`}
                        >
                            <BarIcon Icon={Icon} badge={badges[key]} />
                            <span className="bottom-nav__label" aria-hidden="true">{shortLabel}</span>
                        </NavLink>
                    </li>
                ))}
                {overflow.length > 0 && (
                    <li className="bottom-nav__item">
                        <button
                            type="button"
                            className={`bottom-nav__link${isOverflowActive ? ' bottom-nav__link--active' : ''}`}
                            aria-haspopup="dialog"
                            aria-expanded={isMoreOpen}
                            aria-label={`Más: ${overflow.map((item) => item.label).join(', ')}`}
                            onClick={() => setIsMoreOpen(true)}
                        >
                            <BarIcon Icon={MoreIcon} badge={overflowBadge} />
                            <span className="bottom-nav__label" aria-hidden="true">Más</span>
                        </button>
                    </li>
                )}
            </ul>
            <MoreSheet isOpen={isMoreOpen} items={overflow} badges={badges} onClose={() => setIsMoreOpen(false)} />
        </nav>
    );
}
